function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Icons/Facebookm");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "All-Screens",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Home---1820x1024",
  transform: "translate(-930.000000, -758.000000)"
}, React.createElement("g", {
  id: "popup",
  transform: "translate(664.000000, 557.000000)"
}, React.createElement("g", {
  id: 2,
  transform: "translate(250.000000, 141.000000)"
}, React.createElement("g", {
  id: "Icons/Messenger",
  transform: "translate(16.000000, 60.000000)"
}, React.createElement("circle", {
  id: "Oval",
  fill: "#2196F3",
  fillRule: "nonzero",
  cx: 10,
  cy: 10,
  r: 10
}), React.createElement("g", {
  id: "messenger",
  strokeWidth: 1,
  fillRule: "evenodd",
  transform: "translate(4.000000, 4.000000)",
  fill: "#FFFFFF"
}, React.createElement("path", {
  d: "M5.98888889,0.00116959064 C9.22526316,-0.0626432749 11.9032982,2.50381287 11.977193,5.73997661 C11.9032982,8.97611696 9.22526316,11.5425731 5.98888889,11.4787602 C5.23024561,11.4802807 4.47780117,11.3420819 3.76921637,11.0710643 L2.37843275,11.9398596 C2.33878363,11.9646316 2.29295906,11.9777778 2.24619883,11.9777778 C2.10839766,11.9777778 1.99667836,11.8660585 1.99667836,11.7282573 L1.99667836,10.0116023 C0.73845614,8.94830409 0.00902923977,7.38727485 0.000584795322,5.73995322 C0.0744795322,2.50381287 2.75251462,-0.0626432749 5.98888889,0.00116959064 Z M9.93118129,4.09316959 C9.85693567,3.99366082 9.72081871,3.96388304 9.61181287,4.02329825 L7.01688889,5.43803509 L5.40254971,4.05373099 C5.30355556,3.9688655 5.15590643,3.97450292 5.0637193,4.06671345 L2.06956725,7.0608655 C1.97242105,7.15859649 1.97288889,7.3165848 2.07064327,7.41373099 C2.14879532,7.4914152 2.26863158,7.50863158 2.36549708,7.45609357 L4.96042105,6.04135673 L6.57625731,7.42615205 C6.67525146,7.51101754 6.82290058,7.50538012 6.91508772,7.41316959 L9.90923977,4.41901754 C9.99649123,4.33094737 10.005848,4.19216374 9.93118129,4.09316959 Z",
  id: "Combined-Shape"
})))))));

var SvgMessenger = function SvgMessenger(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMessenger, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/messenger.5a5d1ac1.svg";
export { ForwardRef as ReactComponent };